import {Component, Input, OnInit, ChangeDetectorRef} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {RoleService} from "../role/role.service";
import {UserService} from "../services/user.service";
import { HttpResponse } from "@angular/common/http";
import {PrioritiesService} from "./priorities.service";
import {Router} from "@angular/router";
import {WorkDialogComponent} from "../work/work-dialog/work-dialog.component";
import {WorkService} from "../work/work.service";
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { FirebaseService } from '../services/firebase.service';
import { catchError, of } from 'rxjs';
import { goToDetails, GoToDetailsArgs } from '../utils/navigation/go-to-details';

@Component({
    selector: 'app-priorities',
    templateUrl: './priorities.component.html',
    styleUrls: ['./priorities.component.scss'],
    standalone: false
})
export class PrioritiesComponent implements OnInit {
  priorities: any[] = [];
  @Input() workpoint = false;
  @Output() workCount = new EventEmitter()
  @Output() notificationCount = new EventEmitter()
  works:any[] = [];
  constructor(
    private firebase: FirebaseService,
    private matDialog: MatDialog,
    private roleService: RoleService,
    private userService: UserService,
    private prioritiesService: PrioritiesService,
    private workService: WorkService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit() {
    this.loadWorks();
    this.loadPriorities();
    this.firebase.messages$.subscribe((message) => {
      if(message.data && message.data.type === 'notification'){
        this.loadPriorities();
      }
    });
  }
  loadPriorities(){
    this.prioritiesService.all().then((priorities:HttpResponse<any[]>)=>{
      this.priorities = priorities.body;
      this.emitPriorityCount();
    }).catch((error)=>{
      console.log(error);
    });
  }
  loadWorks(){
    this.workService.own().pipe(
      catchError((error) => {
        console.log(error);
        return of(null);
      }),
    ).subscribe((response:HttpResponse<any>)=>{
      if (!response) return;
      this.works = response.body.items;
      this.emitWorkCount();
    });
  }
  emitPriorityCount(){
    const count = this.priorities.filter((p)=>!p.readed).length;
    this.notificationCount.emit(count);
  }
  emitWorkCount(){
    this.workCount.emit(this.works.length);
  }
  openPriority(priority){
    const index = this.priorities.findIndex((p)=>p === priority);

    if (index < 0) return;

    if(!this.priorities[index].readed){
      this.priorities[index].readed = true;
      this.prioritiesService.complete(priority.id).then(()=>{
        this.loadPriorities();
      }
      ).catch((error)=>{
        console.log(error);
      });
    }
    
    let goToDetailsParams: GoToDetailsArgs = {
      id: priority.model_id,
      type: priority.model_class,
      dialog: this.matDialog,
      mode: 'modal',
    };
    switch(priority.model_class){
      case 'OrderComment':
        goToDetailsParams['id'] = priority.content;
        goToDetailsParams['type'] = 'Order';
        
        if (!this.workpoint){
          goToDetailsParams['mode'] = 'route';
          goToDetailsParams['router'] = this.router;
          goToDetailsParams['queryParams'] = { goto: 'comments', id: priority.model_id};
        }
        break;
      case 'Comment':
        goToDetailsParams['id'] = priority.content;
        goToDetailsParams['type'] = priority.notification_type;
        break;
      case 'Event':
        goToDetailsParams['type'] = priority.notification_type === 'info'
          ? 'Order'
          : priority.notification_type;
        break;
    }
    goToDetails(goToDetailsParams);
        
  }
  openWork(id,type){
    this.matDialog.open(WorkDialogComponent,{data: {id: id, type: type}, minWidth: '80%'}).afterClosed().subscribe(()=>{
      this.loadWorks();
    });
  }
}
